import { render, staticRenderFns } from "./firewalls_page.vue?vue&type=template&id=4f0293d7"
import script from "./firewalls_page.vue?vue&type=script&lang=js"
export * from "./firewalls_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports